module.exports = __webpack_public_path__ + "img/Dave-school-logo.77bc6426.png";